import "./add.scss";

export default function Add(props) {
  return (
    <div className="add-container" onClick={() => props.onClick()}>
      <p style={{ color: "var(--theme-primary)" }}>{props.content}</p>
    </div>
  );
}
